import React from "react";
import { Toaster, ToastBar } from "react-hot-toast";
import Toast from "./Toast";

const NotificationsToaster = () => {
  return (
    <Toaster position="top-center" reverseOrder={true}>
      {(t) => (
        <ToastBar style={{ background: "#F9F9F9", maxWidth: 500 }} toast={t}>
          {(props) => <Toast toast={t} {...props} />}
        </ToastBar>
      )}
    </Toaster>
  );
};

export default NotificationsToaster;
